module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"en":{"title":"Twilight ang golden hour","astroTwilight":"Astronomical twilight","nauticalTwilight":"Nautical twilight","civilTwilight":"Civil twilight","goldenHour":"Golden hour","morning":"Morning","evening":"Evening"},"ru":{"title":"Сумерки и золотой час","astroTwilight":"Астрономические сумерки","nauticalTwilight":"Навигационные сумерки","civilTwilight":"Гражданские сумерки","goldenHour":"Золотой час","morning":"Утро","evening":"Вечер"}}')
}



//////////////////
// WEBPACK FOOTER
// ./node_modules/@kazupon/vue-i18n-loader/lib!./node_modules/vue-loader/lib/selector.js?type=customBlocks&index=0!./src/components/twilight.vue
// module id = 738
// module chunks = 0